"use client";

import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { MuscleButton } from "@modules/shared/components/buttons";
import TimePickerInput from "@modules/cars/components/search/car-search-form/components/time-picker-input";
import { useCarsSearchContext } from "@lib/context/cars/cars-search-context";
import useCssModules from "@lib/hooks/use-css-modules";
import { usePathname } from "next/navigation";
import Icons from "@modules/icons";
export const CarPickupTimeSelection = () => {
  const t = useTranslations("Cars.SearchForm");
  const {
    setNode
  } = useForwardNode();
  const {
    togglePanel
  } = useSideOverPanel();
  const {
    search,
    setSearch
  } = useCarsSearchContext();
  const pathname = usePathname();
  const {
    0: showValidation,
    1: setShowValidation
  } = useState(false);
  const {
    cssModules
  } = useCssModules();
  const {
    destinationSelectionApplyButton,
    destinationSelectionCancelButton,
    destinationSelectionApplyButtonContainer,
    destinationSelectionPanelContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.DestinationSelection) || {};

  // Custom validation for pickup time selection step
  const validatePickupTimeSelection = time => {
    if (!time) {
      return {
        success: false,
        message: "SEARCH_VALIDATIONS.NO_PICKUP_TIME_SELECTED",
        field: "pickUpTime"
      };
    }
    return {
      success: true,
      message: "success",
      field: ""
    };
  };
  const {
    0: validation,
    1: setValidation
  } = useState(() => validatePickupTimeSelection((search === null || search === void 0 ? void 0 : search.pickUpTime) || null));

  // Update validation when inputs change
  useEffect(() => {
    const validation = validatePickupTimeSelection((search === null || search === void 0 ? void 0 : search.pickUpTime) || null);
    setValidation(validation);
  }, [search === null || search === void 0 ? void 0 : search.pickUpTime]);
  const handlePickUpTimeChange = time => {
    if (setSearch) {
      const updatedSearch = _objectSpread(_objectSpread({}, search || {}), {}, {
        pickUpTime: time
      });
      console.log('Mobile updating search:', updatedSearch);
      setSearch(updatedSearch);
    }
  };
  const handleContinue = () => {
    if (validation.success) {
      setNode("CarDropoffTimeSelection");
    } else {
      setShowValidation(true);
    }
  };
  return __jsx("div", {
    className: destinationSelectionPanelContainer
  }, __jsx("div", {
    className: "flex items-center gap-3 "
  }, __jsx(Icons.xIcon, {
    className: "w-6 h-6 cursor-pointer flex-shrink-0",
    onClick: () => togglePanel()
  }), __jsx(TimePickerInput, {
    dataTestId: "pickup-time-mobile",
    value: (search === null || search === void 0 ? void 0 : search.pickUpTime) || undefined,
    onChangeValue: handlePickUpTimeChange,
    hasErrors: showValidation && validation.field === "pickUpTime",
    errorMessage: showValidation && validation.field === "pickUpTime" ? t(validation.message) : undefined,
    className: "flex-1 mb-4",
    hideLabel: true,
    useBorderlessStyle: true,
    placeholder: t("PICKUP_TIME_PLACEHOLDER"),
    showBorder: false
  })), showValidation && validation.field === "pickUpTime" && __jsx("p", {
    className: "px-4 text-xs text-red-600 font-medium"
  }, t(validation.message)), __jsx("div", {
    className: destinationSelectionApplyButtonContainer
  }, __jsx(MuscleButton, {
    variant: "solidXL",
    onClick: handleContinue,
    disabled: !validation.success
  }, t("CONTINUE")), pathname.includes("/cars/search") ? __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: () => setNode("EditCarSelection")
  }, t("MAKE_CHANGES")) : __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: () => togglePanel()
  }, t("CANCEL"))));
};